import React, {useState} from 'react';
import {useNavigate} from 'react-router-dom';
import TextField from './components/TextField';
import {FaLock} from 'react-icons/fa';
import Post from './components/Post';
import ssCompanyLogo from './images/ss-company-logo.svg';

export default function PostFree() {
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const login = () => {
    setLoading(true);
    Post.NewPassword({password}).then(res => {
      setLoading(false);
      if (!res.error) {
        const userBkp = localStorage.getItem('user_bkp');
        if (userBkp) {
          localStorage.setItem('user', userBkp);
        }
        alert(res.success);
        navigate('/login');
      } else {
        alert(res.errorMsg);
      }
    });
  };

  return (
    <div style={styles.bg}>
      {loading && (
        <div style={styles.spinnerOverlay}>
          <div style={styles.spinner} />
          <style>{`@keyframes spin {0%{transform:rotate(0deg);}100%{transform:rotate(360deg);}}`}</style>
        </div>
      )}
      <div style={styles.layer}>
        <div style={styles.imageContainer}>
          <img src={ssCompanyLogo} alt="SS Company" style={styles.logo} />
        </div>
        <h2 style={styles.title}>Generate New Password</h2>
        <div style={styles.card}>
          <TextField
            label="Enter New Password"
            tintColor="#f7797d"
            icon={<FaLock style={{marginLeft: 10}} color="#ffffff" size={25} />}
            value={password}
            type="password"
            onChange={e => setPassword(e.target.value)}
          />
          <button style={styles.loginBtn} onClick={login}>
            <span style={styles.loginBtnText}>Next</span>
          </button>
        </div>
      </div>
    </div>
  );
}

const styles = {
  bg: {
    minHeight: '100vh',
    width: '100%',
    backgroundImage: "url('/images/splash3.jpg')",
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  spinnerOverlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    background: 'rgba(0,0,0,0.3)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 9999,
  },
  spinner: {
    width: 50,
    height: 50,
    border: '6px solid #ccc',
    borderTop: '6px solid #0AB4A7',
    borderRadius: '50%',
    animation: 'spin 1s linear infinite',
  },
  layer: {
    textAlign: 'center',
    color: 'white',
  },
  imageContainer: {
    marginTop: 60,
  },
  logo: {
    width: 250,
    height: 200,
  },
  title: {
    color: 'white',
    fontWeight: 'bold',
    fontSize: 20,
    marginTop: 10,
  },
  card: {
    width: '300px',
    margin: '20px auto',
    borderRadius: '20px',
    padding: '20px',
    backgroundColor: 'rgba(0,0,0,0.4)',
    border: '1px solid #10C2AA',
  },
  loginBtn: {
    width: '100%',
    borderRadius: '10px',
    padding: '15px',
    backgroundColor: '#0AB4A7',
    cursor: 'pointer',
    border: 'none',
    marginTop: '20px',
  },
  loginBtnText: {
    color: 'white',
    fontWeight: 'bold',
    fontSize: 16,
  },
};
